import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importBankAccountVerifySelectContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "WithdrawalContainer" */
                '@perpay-web/fintech/components/containers/BankAccountVerifySelectContainer'
            ),
    );
